import { get, flatten, isUndefined, max } from 'lodash';
import { MODEL, PRACTICE, QUESTIONS } from '../constants/assessmentItemType';

export const getWRState = (state) => state.wr;

export const getWRPracticeQuestions = (state) => state.questions;

export const getIsWRDataFetched = (state) => state.isDataFetched;

export const getWRContent = (state, pageType, questionIndex = undefined) => {
    let content;
    switch (pageType) {
    case MODEL:
        content = state.model;
        break;
    case PRACTICE:
        content = state.practice;
        break;
    case QUESTIONS:
        content = state.questions;
        break;
    default:
        return {};
    }
    if (!isUndefined(questionIndex)) {
        content = content[questionIndex] || {};
    }
    return content;
};

export const getWRMaxResponseLength = (state, pageType) => {
    const content = getWRContent(state, pageType);
    return max(flatten(content.map((itemContent) => itemContent.possibleResponses.map((possibleResponse) => possibleResponse.text.length))));
};

export const getWRPossibleResponses = (state, pageType, questionIndex = 0) =>
    get(getWRContent(state, pageType, questionIndex), 'possibleResponses', []);

export const getWRStimulusAudio = (state, pageType, questionIndex = 0) =>
    get(getWRContent(state, pageType, questionIndex), 'stimulus.stimulusAudio', '');

/**
 * Note: it is expected that getWRCorrectResponseIndex will always
 * return `undefined` for QUESTIONS pageType since front end does not know
 * which response is correct. That is calculated on back end
 */
export const getWRCorrectResponseIndex = (state, pageType, questionIndex = 0) => {
    if (pageType === QUESTIONS) {
        return undefined;
    }

    const content = getWRContent(state, pageType, questionIndex);
    const possibleResponses = getWRPossibleResponses(state, pageType);
    return possibleResponses.findIndex((possibleResponse) => possibleResponse.id === content.correctResponse.id);
};

export const isWRMeasureCompleted = (state, questionIndex) => state.questionsCount === questionIndex;

export const getWRFormId = (state) => state.formId;
